import { withTranslation } from "react-i18next";

import React, { Component } from 'react';
import { Chart } from 'react-google-charts';
import '../../assets/css/tree.css';
import Affiliator from '../../Models/Affiliator';
import { Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Spinner } from 'reactstrap';
import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';

class AffiliatorMLMTree extends Component {

    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('0'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            title: null,
            data: [],
            response_status: 0
        };
        this.getTree();
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getTree() {
        let x = JSON.parse(localStorage.getItem('info'))
        Affiliator.getAffiliatorTree(x.id).then(res => {
            console.log(res.data)
            this.setState({ data: res.data })
            this.setState({ response_status: 200 })
        })
    }
    render() {


        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name small-hidden">
                                    <AffiliatorSidebar />
                                </div>
                                <div className="col-md-8">
                                    <div className=" mb-3 input_name big_font guide_text pages_headers" style={{width:'100%'}}>
                                        {this.props.t('1')}
                                    </div>

                                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                                        {(() => {
                                            if (this.state.response_status === 200) {
                                                return (
                                                    <div id="tree" className="" style={{width: "100%", overflowY: "hidden"}}>
                                                        <Chart
                                                            width={'100%'}
                                                            height={'100%'}
                                                            chartType="OrgChart"
                                                            loader={<div></div>}
                                                            data={this.state.data}
                                                            options={{ allowHtml: true }}
                                                            rootProps={{ 'data-testid': '1' }}
                                                        />
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div className="container-fluid">
                                                        <div className="container">
                                                            <div className="" style={{ height: '100px' }}></div>
                                                            <div className="text-center mt-3">
                                                                <Spinner color="primary" size="150" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })()}


                                        {/* <Chart
                                            width={'100%'}
                                            height={350}
                                            chartType="OrgChart"
                                            loader={<div>Loading Chart</div>}
                                            data={[
                                                ['Name', 'Manager', 'ToolTip'],
                                                [
                                                    {
                                                        v: 'Mike',
                                                        f: 'Mike<div style="color:red; font-style:italic">President</div>',
                                                    },
                                                    '',
                                                    'The President',
                                                ],
                                                [
                                                    {
                                                        v: 'Jim',
                                                        f:
                                                            'Jim<div style="color:red; font-style:italic">Vice President</div>',
                                                    },
                                                    'Mike',
                                                    'VP',
                                                ],
                                                ['Alice', 'Mike', ''],
                                                ['Bob', 'Jim', 'Bob Sponge'],
                                                ['Carol', 'Bob', ''],
                                                ['Ashik', 'Bob', ''],
                                                ['sabik', 'Bob', ''],
                                                ['Carol', 'Bob', ''],
                                                [
                                                    {
                                                        v: 'Carol1',
                                                        f: 'Carol-1',
                                                    },
                                                    'Bob',
                                                    'The President',
                                                ],
                                                ['Carol', 'Bob', ''],
                                                ['Carol', 'Bob', ''],
                                            ]}
                                            options={{
                                                allowHtml: true,
                                            }}
                                            rootProps={{ 'data-testid': '1' }}
                                        /> */}


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { AffiliatorMLMTree };


AffiliatorMLMTree = withTranslation('src_Components_Affiliator_MLMTree')(AffiliatorMLMTree);
